import React from 'react';
import { IContextualMenuItem } from '@fluentui/react';

type MergeFieldContextType = {
  mergeFields: Array<IContextualMenuItem> | (() => Array<IContextualMenuItem>);
};

const MergeFieldContext = React.createContext({ mergeFields: [] } as MergeFieldContextType);
export default MergeFieldContext;
